"use client"

import { ShieldUser } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ShieldUserIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ShieldUserIcon = component(Icon)({ as: ShieldUser })
